import React from 'react';
export function WhySection() {
  return <>
      <section className="border-b border-navy/10 bg-white px-3 py-4 sm:px-6" data-id="element-159" data-mp="h18whbyucjx2">
        <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="13vt4m45kcu1o">
          <h2 className="text-center text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.7rem]" data-id="element-161" data-mp="18ucqk4k5q5u1">
            Stop trying to understand ultrasound from text alone
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-162" data-mp="1ik61r4ge0ixr">
            Not sure how probe position connects to the image? Normal anatomy
            looks different every time you change the scanning plane?
            Anechoic, hypoechoic, shadowing, enhancement, Doppler, artifacts...
            what exactly should you be looking for? ULTRASOUND VISUAL ATLAS™
            gives you an organized visual study system to help you understand
            sonographic anatomy, compare appearances and recognize important
            ultrasound patterns.
          </p>
          <p className="mt-1 text-center text-[0.72rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.85rem]" data-id="element-163" data-mp="27qzvt32eud4">
            Scan. Compare. Recognize.
          </p>
        </div>
      </section>

      <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-164" data-mp="28ptq8xj1tlpi">
        <div className="mx-auto max-w-2xl" data-id="element-165" data-mp="28qd7sd4se830">
          <h2 className="text-center text-[1.05rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-166" data-mp="24o8exgm5xfhf">
            😩 Stop searching through different references for every
            ultrasound topic
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-167" data-mp="2wghbsllw09uj">
            You already study ultrasound. The problem is wasting time jumping
            between textbooks, lecture slides, websites and disconnected images
            just to understand what you're actually seeing. Open the system,
            choose the body region or ultrasound concept and follow the visual
            references.
          </p>
          <p className="mt-1 text-center text-[0.72rem] font-extrabold uppercase tracking-wide text-sono sm:text-[0.85rem]" data-id="element-168" data-mp="1by9ophw8fcb6">
            Less searching. More structured learning.
          </p>
        </div>
      </section>
    </>;
}